import { suggestionBadge } from '@/views/content/suggestionBadge'

export default [
  {
    header: 'Контент',
  },
  {
    title: 'Предложка',
    route: 'content-suggestions',
    icon: 'InboxIcon',
    tagVariant: 'light-warning',
    // Число pending-предложек; рендер меню трекает observable — бэдж обновляется реактивно.
    get tag() {
      return suggestionBadge.count
    },
  },
]
